// buildingList.js
// Export an array of building objects for the location dropdown in meeting scheduling.
// Example: { name: 'Milner Library', lat: 40.509, lng: -88.991 }

const buildingList = [
  { name: "Milner Library", lat: 40.5113473, lng: -88.9908402 },
  { name: "Bone Student Center", lat: 40.5118535, lng: -88.9918811 },
  { name: "Schroeder Hall", lat: 40.5104386, lng: -88.9918058 },
  { name: "Stevenson Hall", lat: 40.5082294, lng: -88.98902059999999 },
  { name: "CEFCU Arena", lat: 40.5107074, lng: -88.9987788 },
  { name: "Hancock Stadium", lat: 40.5123117, lng: -88.9965575 },
  { name: "Watterson Towers", lat: 40.5083661, lng: -88.9875643 },
  { name: "Cook Hall", lat: 40.5093696, lng: -88.99215939999999 },
  { name: "Center for the Performing Arts", lat: 40.5075616, lng: -88.9899568 },
  { name: "Center for the Visual Arts", lat: 40.507235, lng: -88.99073849999999 },
  { name: "Julian Hall", lat: 40.5096038, lng: -88.9877379 },
  { name: "Felmley Hall of Science", lat: 40.5103526, lng: -88.99090939999999 },
  { name: "Haynie Hall", lat: 40.5124079, lng: -88.9999136 },
  { name: "Moulton Hall", lat: 40.5098856, lng: -88.9904096 },
  // Add or correct more buildings as needed
];

export default buildingList;
